import { render, staticRenderFns } from "./Privacy2.vue?vue&type=template&id=4de36cae&scoped=true"
import script from "./Privacy2.vue?vue&type=script&lang=js"
export * from "./Privacy2.vue?vue&type=script&lang=js"
import style0 from "./Privacy2.vue?vue&type=style&index=0&id=4de36cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de36cae",
  null
  
)

export default component.exports